import Mapper from './Mapper';

export default class BaseService {
    #url = '';
    #id = '';
    #mapper = null;
    constructor(
        url,
        id,
        order,
        options = {
            paramName: {
                json: null,
                files: 'file',
            },
        }
    ) {
        const { mapper = new Mapper(), ...rest } = options ?? {};
        this.#mapper = mapper;
        this.#mapper.setOptions(rest);
        this.#url = url;
        this.#id = id ?? 'id';
        this.options = rest;
        this.order = order ?? [{ field: 'id', order: 'asc' }];
    }

    getMapper() {
        return this.#mapper;
    }

    getUrl() {
        return this.#url;
    }

    getId() {
        return this.#id;
    }

    async beforeSelectOnAlter(res, formController) {
        const data = await this.#mapper.formatToInput(res, formController);
        return Mapper.setEmptyInNull(data);
    }

    async beforeSave({ registro }) {
        const data = registro.constructor.name !== 'FormData' ? JSON.stringify(registro) : registro;

        const config =
            registro.constructor.name !== 'FormData'
                ? {}
                : {
                      headers: {
                          'Content-Type': 'multipart/form-data',
                      },
                  };
        return { data, config: config };
    }

    getSaveUrl({ id = null }) {
        return { criarURL: `${this.#url}`, alterarURL: `${this.#url}/${id}` };
    }

    async getIdUpdate(data) {
        const idKey = this.#id;
        return typeof data === 'string' ? JSON.parse(data)[idKey] : data[idKey];
    }

    async alterar({ registro, original, completeData, params }) {
        const { data, config = {} } = await this.beforeSave({
            criar: false,
            registro,
            original,
            completeData,
        });
        const id = await this.getIdUpdate(data);
        const { alterarURL } = this.getSaveUrl({ id, params });
        const res = await window.$http.put(`${alterarURL}`, data, config);
        return res.data;
    }

    async criar({ registro, original, completeData, params }) {
        const { data, config } = await this.beforeSave({
            criar: true,
            registro,
            original,
            completeData,
        });
        const { criarURL } = this.getSaveUrl({ params });
        const res = await window.$http.post(`${criarURL}`, data, config);
        return res.data;
    }

    async salvar({ registro, formController, params }) {
        const { data, original, completeData } = await this.#mapper.formatToSend(
            formController,
            registro,
            params
        );

        let method = registro[this.#id] && registro[this.#id] !== 0 ? 'alterar' : 'criar';

        return this[method]({ registro: data, original, completeData, params });
    }

    async alterarStatus(registro, novoStatus) {
        await window.$http.patch(`${this.#url}/ativar/${registro[this.#id]}`, {
            ativo: novoStatus,
        });
        return '';
    }
    async remover(registro) {
        const id = this.#id;
        await window.$http.delete(`${this.#url}/${registro[id]}`);
        return '';
    }

    async list(params) {
        const response = await window.$http.get(`${this.#url}/find-list`, params);
        return response.data;
    }

    async beforeSetList(dados, config) {
        const dadosFormatados = await this.getMapper().formatToView(dados, config);
        return dadosFormatados;
    }

    getPesquisarUrl(pagination) {
        return { url: `${this.#url}`, pagination };
    }

    async pesquisar(paginate) {
        paginate.sort = this.order;
        const { url, pagination } = this.getPesquisarUrl(paginate);
        const res = await window.$http.get(url, pagination.getParams());
        return res?.data ?? [];
    }

    getBuscarUrl({ id }) {
        return `${this.#url}/${id}`;
    }

    async buscarPorId(params) {
        const res = await window.$http.get(`${this.#url}/${params[this.getId()]}`);
        return res.data;
    }

    async beforeExport({ body }) {
        return body;
    }

    async exportaDataToFile(params, type, titleFile, filter, configuracao) {
        const exportConfig = this.getExportConfig(type, configuracao);
        const typeRoute = type === 'print' ? 'pdf' : type;
        const body = await this.beforeExport({
            params,
            body: {
                title: titleFile,
                ...exportConfig,
                ...filter,
            },
        });

        const res = await window.$http.post(`${this.#url}/export/${typeRoute}`, body, {
            responseType: 'blob',
        });

        return res.data;
    }
    getExportConfig(type, configuracao) {
        if (configuracao[type]) {
            return {
                columns: configuracao[type].columns,
                properties: configuracao[type]['properties'],
            };
        }
        return {
            columns: configuracao.columns,
            properties: configuracao.properties,
        };
    }
}
